import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";
import image from "../../assets/images/upload.svg";
import doc from "../../assets/images/doc.svg";
import Close from "../SVG/Close";

export default function Dropzone(props) {
  const { onDrop: handleDrop, ...rest } = props;
  const [fileName, setFileName] = useState("");
  const [error, setError] = useState(false);
  const onDrop = useCallback(
    acceptedFiles => {
      if (!acceptedFiles.length) {
        setFileName("");
        setError(true);
        return handleDrop(null);
      }
      const [file] = acceptedFiles;
      setError(false);
      setFileName(file.name);
      return handleDrop(acceptedFiles);
    },
    [handleDrop]
  );
  const { getRootProps, getInputProps } = useDropzone({
    ...rest,
    onDrop
  });
  const handleRemove = evt => {
    evt.stopPropagation();
    setFileName("");
    setError(false);
    handleDrop(null);
  };

  return (
    <div {...getRootProps()} className={`file-input ${fileName && "file"}`}>
      <input {...getInputProps()} />
      {error && (
        <p className="error">Not valid format. Accepted List: {props.accept}</p>
      )}
      {!error && !fileName && (
        <div className="file-container">
          <img src={image} alt="upload" />
          <p>Upload Zipcode</p>
        </div>
      )}
      {!error && fileName && (
        <div className="file-container">
          <img src={doc} alt="document" />
          <p>{fileName}</p>
          <Close onClick={handleRemove} className="remove" />
        </div>
      )}
    </div>
  );
}

Dropzone.propTypes = {
  onDrop: PropTypes.func.isRequired,
  accept: PropTypes.string.isRequired
};
